/**
 * Part of nthu-ctm-oia project.
 *
 * @copyright  Copyright (C) 2022 __ORGANIZATION__.
 * @license    __LICENSE__
 */
const articleContents = document.querySelectorAll('.article-content');

articleContents.forEach((e) => {
  const sectionTitles = e.querySelectorAll('h1, h2, h3, h4, h5, h6');

  sectionTitles.forEach((e) => {
    let html = '<span class="h-section-title-icon"><i class="fa-light fa-thumbtack"></i></span>';
    html = html + `<span>${e.textContent}</span>`;

    e.classList.add('d-flex', 'align-items-center');
    e.innerHTML = html;
  });
});
